import clsx from "clsx";
import React, { memo, forwardRef } from "react";

interface CoreVideoProps {
  className?: string;
  muted?: boolean;
  onWaiting?: () => void;
  onCanPlay?: () => void;
  onPlay?: (event: React.SyntheticEvent<HTMLVideoElement>) => void;
  onPause?: (event: React.SyntheticEvent<HTMLVideoElement>) => void;
  onTimeUpdate?: (event: React.SyntheticEvent<HTMLVideoElement>) => void;
  onLoadedMetadata?: (event: React.SyntheticEvent<HTMLVideoElement>) => void;
  onEnded?: (event: React.SyntheticEvent<HTMLVideoElement>) => void;
}

export const CoreVideo = memo(
  forwardRef<HTMLVideoElement, CoreVideoProps>(
    (
      {
        className,
        muted,
        onWaiting,
        onCanPlay,
        onPlay,
        onPause,
        onTimeUpdate,
        onLoadedMetadata,
        onEnded,
      },
      ref
    ) => {
      return (
        <video
          ref={ref}
          className={clsx("w-full h-full aspect-video", className)}
          muted={muted}
          controls={false}
          preload="metadata"
          playsInline
          onWaiting={onWaiting}
          onCanPlay={onCanPlay}
          onPlay={onPlay}
          onPause={onPause}
          onTimeUpdate={onTimeUpdate}
          onLoadedMetadata={onLoadedMetadata}
          onEnded={onEnded}
        />
      );
    }
  )
);

CoreVideo.displayName = "CoreVideo";
